<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/57/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/57/title-1.png" alt="" />
                    <div class="content">
                        在我区工作的专家人才，参与推动实施创新驱动发展战略，创新或专业技术水平全市领先、西部一流，在生产、科研、管理和服务等领域作出突出贡献，遵纪守法、德才兼备、身体健康，能够胜任正常工作。
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/57/title-2.png" alt="" />
                    <div class="content">
                        <div class="text">
                            （一）在技术、商业模式创新中，突破重大技术瓶颈或市场制约，研发应用新技术、新产品、新工艺，开辟新市场，取得显著经济社会效益，得到市场和同行公认的创新人才和高技能人才。
                        </div>
                        <div class="text">
                            （二）在企事业单位管理创新中，运用现代管理方法进行科学管理，取得显著经济和社会效益，得到市场和同行公认的优秀管理者。
                        </div>
                        <div class="text">
                            （三）在推动我区全国双创示范基地建设中，创新能力强、创业项目优、发展潜力大，能够发挥较好示范、引领、带动作用的创新创业人才。
                        </div>
                        <div class="text">
                            （四）在我区统筹城乡发展中，创新体制机制，加大统筹力度，理论探索和实践效果显著，受到区委、区政府及以上表彰或肯定，在推进城乡形态转型升级中作出较大贡献的专家人才。
                        </div>
                        <div class="text">
                            （五）在我区改善民生和创新社会管理中，业绩突出、同行认可，知名度高的名师、名医、社会工作专业人才和促进就业典型等优秀人才。
                        </div>
                        <div class="text">
                            （六）在推进我区都市现代农业发展中，在农业科研、科技成果转化或农业科技推广运用方面有较大突破和贡献，引领农民增收、推动农村繁荣成效显著，在本行业领域具有较高知名度的代表人才。
                        </div>
                        <div class="text">
                            （七）在推动我区文化旅游、体育事业、改革发展中，德艺双馨、贡献突出，同行业中知名度较高的哲学、社会科学、新闻出版、旅游、广播影视、文艺体育、文化产业等领域的优秀人才。
                        </div>
                        <div class="text">
                            （八）在推动我区城市管理转型升级中，理念创新、工作先进、成效显著、社会认可的规划、建设、管理和生态保护方面的优秀人才。
                        </div>
                        <div class="text">
                            （九）在推动我区现代服务业发展中，同行认可、贡献突出的金融保险、现代物流、商业服务、科技信息服务、服务外包等方面的优秀人才。
                        </div>
                        <div class="text">
                            （十）在其他领域中，工作出色、绩效突出，作出较大贡献并有较高声誉的专家人才。
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/57/title-3.png" alt="" />
                    <div class="content">
                        <div class="text">
                            （一）发给区优专家津贴 20 万元，逐年发放，每年 4
                            万元，主要用于开展课题研究、参加学术交流、出版著作、发表论文、购买图书资料等。
                        </div>
                        <div class="text">
                            （二）每年组织区优专家进行一次全面体检，建立健康档案。
                        </div>
                        <div class="text">
                            （三）资助区优专家围绕区委中心工作开展研究，其成果被区委、区政府采纳的给予适当奖励。
                        </div>
                        <div class="text">
                            （四）区优专家医疗待遇、子女入学参照《关于改善优秀专家医疗待遇的意见》《对引进高层次人才的子女就读中小学实行特殊优惠的实施办法》有关规定执行，区委组织部、区人社局、区卫健局、区教育局做好协调服务工作。
                        </div>
                        <div class="text">
                            （五）每年组织区优专家进行疗养休假。
                        </div>
                        <div class="text">
                            （六）同等条件下优先推荐区优专家为各级党代表、人大代表候选人和政协委员人选。
                        </div>
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/57/title-4.png" alt="" />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">组织推荐</div>
                                </div>
                                <div class="line-content">
                                    每五年选拔一次。<br />
                                    各镇（街道）和区级部门、产业园区采取单位推荐、专家举荐或个人自荐等方式，经公示确定本地、本系统推荐人选。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">资格审查</div>
                                </div>
                                <div class="line-content">
                                    区委组织部会同区人社局、区经信局等相关部门，按照区优专家选拔条件进行资格审查，确定初步人选。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">专家评审</div>
                                </div>
                                <div class="line-content">
                                    区委组织会同区人社局、区经信局等有关部门邀请专家组成专业评审委员会，按人才类型或专业领域，对初步人选的专业水平、业绩贡献等进行分组评审，确定建议人选。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line" style="height: 180%"></div>
                                    <div class="line-num">4</div>
                                    <div class="line-title">实地考察</div>
                                </div>
                                <div class="line-content">
                                    区委组织部牵头组织成立考察组，对建议人选进行德、能、勤、廉全面考察，确定拟授人选。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">5</div>
                                    <div class="line-title">批准</div>
                                </div>
                                <div class="line-content">
                                    将拟授人选名单提交区委常委会审定。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">6</div>
                                    <div class="line-title">公示</div>
                                </div>
                                <div class="line-content">
                                    对拟授人选进行为期5个工作日的公示。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">7</div>
                                    <div class="line-title">
                                        确定人选颁发入选证书
                                    </div>
                                </div>
                                <div class="line-content">
                                    以区委、区政府名义颁发“郫都区有突出贡献的专家证书”
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="contact" style="margin-top: 0.8rem">
                    <img class="top" src="./../assets/imgs/25/title-5.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-87987877">028-87987877</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            区委组织部（区委人才办）
                        </div>
                        <!-- <div>
                                政策咨询电话：
                                <a href="tel:028-86259119">028-86259119</a>
                            </div>
                            <div>责任单位：中共成都市青羊区委组织部人才科</div> -->
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/57/code.png" />
                    <img class="text" src="../assets/imgs/57/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                font-size: 0.26rem;
                font-weight: 500;
                color: #4e4e4e;
                text-align: left;
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .text {
                    background-color: #fff;
                    box-sizing: border-box;
                    padding: 0.42rem 0.25rem;
                    font-size: 0.26rem;
                    border-radius: 0.26rem;
                    color: #4e4e4e;
                    margin-top: 0.22rem;
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.5rem;
                    position: relative;

                    .title {
                        font-size: 0.3rem;
                        font-weight: bold;
                        color: #333333;
                    }

                    .item {
                        margin-top: 0.22rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 118%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            position: absolute;
                            font-size: 0.3rem;
                            left: 0.65rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.55rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;

                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.82rem;
            }
        }
    }
}
</style>
